import styled, { css } from 'styled-components';
import { th } from 'style/theme';

export const AccordionHeading = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
  margin-top: 8px;
  font-weight: 500;
  color: ${th('colors.pickledBluewood1')};
  cursor: pointer;

  > svg {
    transition: 200ms;
  }

  ${({ $isOpen }) =>
    $isOpen &&
    css`
      > svg {
        transform: rotate(180deg);
      }
    `};
`;
